import { LocalDate, LocalDateTime } from "@flockcover/flock-svc-core-types"
import { localDateToString } from "@shared/utils/formatters/dates"
import { format as dateFnsFormat } from "date-fns"

export const extractDateFromLocalDateTime = (datetime: LocalDateTime): LocalDate => datetime.split(`T`)[0] as LocalDate

export const toChartDate = (datetime: LocalDateTime): string =>
  `${localDateToString(extractDateFromLocalDateTime(datetime), `en`, `dd MMM`).toUpperCase()}`

export const dateToString = (date: Date, format = `dd MMM`): string => dateFnsFormat(date, format).toUpperCase()

export const chartAnnotation = (
  xMin: number | string | undefined,
  yMin: number | string,
  xMax: number | string | undefined,
  yMax: number | string,
  isSolid?: boolean
) => ({
  type: `line`,
  xMax,
  xMin,
  xScaleID: `x`,
  yMax,
  yMin,
  yScaleID: `y`,
  position: `end`,
  borderColor: `#4f5359`,
  borderWidth: 2,
  borderDash: isSolid ? undefined : [6, 6],
})

export const toPeriodLabel = (periodStart: LocalDateTime, periodEnd: LocalDateTime): string[] => [
  `${toChartDate(periodStart)} -`,
  `${toChartDate(periodEnd)}`,
]

const dateToUnix = (date: Date) => Math.floor(date.getTime() / 1000)

export const inDateTimeRange = (from: LocalDateTime, to: LocalDateTime) => {
  const now = dateToUnix(new Date())
  return now > dateToUnix(new Date(from)) && now < dateToUnix(new Date(to))
}
